import { render, staticRenderFns } from "./AddTicketModal.vue?vue&type=template&id=2975db08&scoped=true"
import script from "./AddTicketModal.vue?vue&type=script&lang=js"
export * from "./AddTicketModal.vue?vue&type=script&lang=js"
import style0 from "./AddTicketModal.vue?vue&type=style&index=0&id=2975db08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2975db08",
  null
  
)

export default component.exports